import * as React from "react";
const EventSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={17}
    fill="none"
    {...props}
  >
    <path
      fill="#934816"
      d="M9.667 12.28a1.61 1.61 0 0 1-1.184-.483A1.61 1.61 0 0 1 8 10.613c0-.466.161-.86.483-1.183a1.61 1.61 0 0 1 1.184-.483c.466 0 .86.16 1.183.483.322.322.483.717.483 1.183 0 .467-.16.861-.483 1.184a1.61 1.61 0 0 1-1.183.483Zm-6.334 2.667c-.366 0-.68-.13-.941-.392A1.286 1.286 0 0 1 2 13.613V4.28c0-.367.13-.68.392-.941.261-.261.575-.392.941-.392H4V1.613h1.333v1.334h5.334V1.613H12v1.334h.667c.366 0 .68.13.942.392.261.261.391.575.391.941v9.333c0 .367-.13.68-.391.942a1.28 1.28 0 0 1-.942.392H3.333Zm0-1.334h9.334V6.947H3.333v6.666Zm0-8h9.334V4.28H3.333v1.333Z"
    />
  </svg>
);
export default EventSVG;
